import axios from 'axios';

const api = axios.create({
  baseURL: 'https://others-tirvu-parceiros-frontend.pvuzyy.easypanel.host/api',
});

// Add a request interceptor to add the auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
